import { useState, useEffect, useMemo } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Center,
  Box,
  Text
} from "@chakra-ui/react";
import { useSession } from "next-auth/client"
import { History } from "components/dm/history";
import { getAccount } from "utils/sessionHelper";
import { firebaseClient } from "firebaseClient";
import PuffLoader from "react-spinners/PuffLoader";
import { useFirebaseUser } from "utils/useFirebaseUser";


export function DmHistoryPopup({ idTweet, isOpen, onClose }) {
  
  const [history, setHistory] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [session] = useSession();
  const isAuthenticated = useFirebaseUser();
  const [nbSuccess, nbFailed] = useMemo(() => {
    let successCount = 0, failCount = 0
    history.forEach(h => {
      if (h.status === "sent") {
        successCount++;
      } else if (h.status === "error") {
        failCount++;
      }
    })
    return [successCount, failCount]
  }, [history])

  const getHistory = async () => {
    // console.log(getAccount(session));
    setIsLoading(true);
    const db = firebaseClient.firestore();
    let docs = await db.collection("users").doc(getAccount(session).id).collection("accounts").doc(getAccount(session).idAccount).collection("dms").where("idTweet", "==", idTweet).get();
    let historyTemp = [] as any;
    historyTemp = docs.docs.map(doc => {return {...doc.data(), id: doc.id}});
    setHistory(historyTemp);
    setIsLoading(false);
  }

  useEffect(() => {
    if (isOpen && isAuthenticated) {
      getHistory();
    }
  }, [isOpen])

  return (
    <Modal onClose={onClose} size="4xl" isOpen={isOpen}>
      <ModalOverlay />
      <ModalContent p="2">
        <ModalHeader fontWeight="bold">
          DM History
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {
            isLoading ? (
              <Center pt={10} h="400px">
                <PuffLoader
                  color={"hsl(203, 100%, 36%)"}
                  loading={true}
                  css="display: block; margin: 0 auto; border-color: red;"
                  size={50}
                />
              </Center>
            ) : (
              history?.length > 0 ? (
                <Box>
                  <Text fontWeight="semibold" textAlign="center" fontSize="md">Successfully sent {nbSuccess} dms. Error in sending {nbFailed} dms.</Text>
                  <History history={history} disableHeader={true} mt={0} />
                </Box>
              ) : (
                <Center pt={10} h="400px">
                  No history found
                </Center>
              )
            )
          }
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
